import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {SnackbarData} from '../models';

@Component({
  selector: 'lib-operation-result-snack-bar',
  imports: [],
  templateUrl: './operation-result-snack-bar.component.html',
  styleUrl: './operation-result-snack-bar.component.scss'
})
export class OperationResultSnackBarComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData) {
  }

}
